import { ImageWrapper } from './PrimaryIcon.styles';
import { IconProps } from './PrimaryIcon.types';
import { getImageUrl } from './PrimaryIcon.utils';

export const PrimaryIcon = ({ market }: IconProps) => (
  <ImageWrapper market={market} src={getImageUrl(market)} alt="Sembo Logo" />
);
